// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-accounts__table {
    border: 1px solid #ccc;
    padding: 0.5rem 3.6rem;
}

.contact-accounts__btn-header {}

.contact-accounts__table tr {
    border: none;
}

.contact-accounts__table td {
    padding: 1rem 0.9rem;
    text-align: left;
    white-space: nowrap;
    min-width: 8rem;
    max-width: 18rem;
}

.contact-account__btn {
    margin: 0 0.7rem;
    font-size: 1.3rem;
    padding: 0 auto;
}

.contact-accounts__no-records {
    margin: 0 7.2rem;
}`, "",{"version":3,"sources":["webpack://./src/app/contact/contact-main/contact-list/contact-item/contact-item-info/contact-account-list/ContactAccountList.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA,+BAA+B;;AAE/B;IACI,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".contact-accounts__table {\r\n    border: 1px solid #ccc;\r\n    padding: 0.5rem 3.6rem;\r\n}\r\n\r\n.contact-accounts__btn-header {}\r\n\r\n.contact-accounts__table tr {\r\n    border: none;\r\n}\r\n\r\n.contact-accounts__table td {\r\n    padding: 1rem 0.9rem;\r\n    text-align: left;\r\n    white-space: nowrap;\r\n    min-width: 8rem;\r\n    max-width: 18rem;\r\n}\r\n\r\n.contact-account__btn {\r\n    margin: 0 0.7rem;\r\n    font-size: 1.3rem;\r\n    padding: 0 auto;\r\n}\r\n\r\n.contact-accounts__no-records {\r\n    margin: 0 7.2rem;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
